'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'Служба наразі недоступна, спробуйте пізніше.',
    NEED_ACTIVE: 'Обліковий запис {{account}} використовує цей веб-сайт вперше. Просимо {{activeLink}}, щоб завершити активацію. Опісля ви зможете повернутися на цю сторінку, щоб продовжити роботу',
    GOTO_ACTIVE: 'Активувати',
    NOT_ACTIVED: 'Обліковий запис не вдалося успішно активувати. Просимо {{activeLink}}, щоб завершити активацію',
    COMPLETE_ACTIVE: 'Підтвердити активацію',
    FORBID_ACTIVE: 'Цей обліковий запис не підтримується AliExpress!',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'Увійдіть, використовуючи інший обліковий запис',
    ACTIVE_PAGE: 'Перейдіть на сторінку активації облікового запису'
};